import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


const vUI_Currency_Search_Fields: {[id: string]: ISearchProviderField} = {
    WB_CURRENCY_ID:    {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Wb Currency Id',     columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {} },
    CURRENCY_ID:       {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'External Currency ID',        columnResourceName: 'colCurrencyId',             alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CURRENCY_NAME:     {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Currency Name',      columnResourceName: 'colCurrencyName',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CURRENCY_SYMBOL:     {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Currency Symbol',      columnResourceName: 'colCurrencySymbol',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CURRENCY_SYMBOL_POSITION:     {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Currency Symbol Position',      columnResourceName: 'colCurrencySymbolPosition',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    DECIMAL_SYMBOL:     {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Decimal Symbol',      columnResourceName: 'colDecimalSymbol',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    DECIMAL_DIGITS:     {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'No. of Digits after Decimal',      columnResourceName: 'colDecimalDigits',   numberFormat: "#0",   alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    GROUPING_SYMBOL:  {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Digit Grouping Symbol',      columnResourceName: 'colGroupingSymbol',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    NEGATIVE_FORMAT:  {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Negative Format',      columnResourceName: 'colNegativeFormat',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    ENTERPRISE_SET_ID:  {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Enterprise Set ID',      columnResourceName: 'colEnterpriseSet',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    ISO_CURRENCY:  {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'ISO ID',      columnResourceName: 'colIso',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    MDSET_NAME: {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Master Data Set', columnResourceName: 'colMDSet', alignment: HorizAlignment.Left }, domainOptions: { maxLength: 256 }},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

const SimulationInputSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_CURRENCY_ID',
        id_ui: 'CURRENCY_ID',
        name:  'CURRENCY_NAME'

    },

    searchProviderFields: vUI_Currency_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Currency_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const CurrencySearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "CurrencySearchProfileByName"},

    profileFilter: [
        //    {profileFilterName: 'Enterprise Set ID', searchProviderFieldId: 'ENTERPRISE_SET_ID', renderOptions: {}},
        {profileFilterName: 'Ext. Currency ID', searchProviderFieldId: 'CURRENCY_ID', renderOptions: {}},
        {profileFilterName: 'Currency Name', searchProviderFieldId: 'CURRENCY_NAME', renderOptions: {}},
        {profileFilterName: 'ISO ID', searchProviderFieldId: 'ISO_CURRENCY', renderOptions: {}},
    ], //ISearchFields
    profileDisplayFields: [
        // 'ENTERPRISE_SET_ID',
        'ISO_CURRENCY','CURRENCY_ID', 'CURRENCY_NAME', 'CURRENCY_SYMBOL','NEGATIVE_FORMAT', 'DECIMAL_SYMBOL', 'DECIMAL_DIGITS', 'CURRENCY_SYMBOL_POSITION',
        'GROUPING_SYMBOL', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: SimulationInputSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const CurrencySearch: ISearch = {
    searchName: "Find Currency",
    renderOptions: {ui5ResourceId: "CurrencySearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [CurrencySearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("CurrencyBO", "Currency", CurrencySearch, "Currency Search")

export {CurrencySearch}